import { createPersistedState } from "@edreamsodigeo/frontend-core";

export const HAS_WELCOME_BACK_TO_PRIME_BEEN_SHOWN_KEY =
  "hasWelcomeBackToPrimeBeenShown";

export const useHasWelcomeBackToPrimeBeenShown = createPersistedState({
  key: HAS_WELCOME_BACK_TO_PRIME_BEEN_SHOWN_KEY,
  type: "localStorage",
  isGlobal: true,
});
